import { Unit } from 'uom';
import { SYMBOL_TO_UNIT_MAPPING } from 'src/modules/common/constants';

type ParsedUnit = {
    value: number;
    unit: Unit.Unit<unknown>;
}

export const parseStringToUnit = (stringToParse: string): ParsedUnit[] => {
    const secondUnitRegex = /(\[.+\])/;
    const array = stringToParse.split(secondUnitRegex);

    try {
        return array.reduce((soFar, curr) => {
            if (!curr) {
                return soFar;
            }

            const unitValue = Number(curr.replace(/[^\d+.?\d+]/g, ''));
            const unitSymbol = curr.replace(/[\d+.?\d+]|\[|\]|\s|\u200b/g, '');

            if (Number.isNaN(unitValue)) {
                throw new Error(`Invalid unit value: ${unitValue}`);
            }

            const unit = SYMBOL_TO_UNIT_MAPPING[unitSymbol];

            if (!unit) {
                throw new Error(`Invalid unit symbol: ${unitSymbol}`);
            }

            return [
                ...soFar,
                {
                    value: unitValue,
                    unit,
                },
            ];
        }, [] as Array<ParsedUnit>);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(`Error parsing unit: ${error} in ${stringToParse}`);

        return [];
    }
};
